// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UwXby","title":"styles_title__XmoFU","items":"styles_items__3x-Rz","value":"styles_value__wSCtG"};